import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import { getThemeClassName } from 'lib/theme/themeUtils'
import TextButton from 'LuxKit/Button/TextButton'
import { CRUISE_ROUTES } from 'constants/cruise'

interface Props {
  offerList: App.OfferList
}

function CruisePageFlashOffersCarousel({ offerList }: Props) {
  const intl = useIntl()

  const viewMoreLabel = intl.formatMessage({
    id: '8oJIkMAAwP',
    defaultMessage: 'View More',
    description: 'Button text to view more top cruise offers',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="2zs/NrWyQw"
            defaultMessage="Today’s top <i>cruise</i> offers"
            description="Section heading for top cruise offers carousel"
            values={{ i: (chunks) => <i>{chunks}</i> }}
          />
        </Heading>
        <TextButton kind="tertiary" to={`${CRUISE_ROUTES.SEARCH_PAGE}`}>{viewMoreLabel}</TextButton>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageFlashOffersCarousel
